import React from "react";
import Button from "../button/button";
import imgwindows from "./assets/windows.png"
import imgapple from "./assets/apple.png"


import { getCurrentKeyboard, setCurrentKeyboard, SearchCurrentKeyBoard} from "../../../utils/software";

class SelectKeyboard extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            currentkeyboard :SearchCurrentKeyBoard(),
        }

        this.onclickwindows = this.onclickwindows.bind(this);
        this.onclickmac = this.onclickmac.bind(this);

    }
    componentDidMount()
    {

    }

    onChange(newkeyboard)
    {
        setCurrentKeyboard(newkeyboard);
        this.setState({currentkeyboard: newkeyboard});
    }



    onclickwindows()
    {   
        this.onChange(0)
    }

    onclickmac()
    {
        this.onChange(1)
    }

    
    
    render()
    {

        const big=30;
        const small=20;
        const winbutton = 
        (
            <Button button={true} image={imgwindows}
                width = {this.state.currentkeyboard===0?big:small}
                height = {this.state.currentkeyboard===0?big:small}
                onClick = {this.onclickwindows}
                tooltip = {{fr:"Clavier Windows",en:"Windows Keyboard"}}
                
            />
        )

        const macbouton = 
        (
            <Button button={true} image={imgapple}
                width = {this.state.currentkeyboard===1?big:small}
                height = {this.state.currentkeyboard===1?big:small}
                onClick = {this.onclickmac}
                tooltip = {{fr:"Clavier Mac",en:"Mac Keyboard"}}
                
            />
        )


        var boutons = 
        (
            <>{winbutton}&nbsp;{macbouton}&nbsp;&nbsp;</>
        )


        return (

            <>

             {boutons}
        </>
        )


    }


}

export default SelectKeyboard